import { defineStore } from 'pinia'
import { ref } from 'vue'
import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api/v1'

export const usePlatformStore = defineStore('platform', () => {
  const maintenanceMode = ref(false)
  const registrationEnabled = ref(true)
  const loaded = ref(false)

  async function fetchStatus(): Promise<void> {
    const { data } = await axios.get<{
      data: { maintenance_mode: boolean; registration_enabled: boolean }
    }>(`${BASE_URL}/public/platform`)
    maintenanceMode.value = Boolean(data.data.maintenance_mode)
    registrationEnabled.value = Boolean(data.data.registration_enabled)
    loaded.value = true
  }

  return {
    maintenanceMode,
    registrationEnabled,
    loaded,
    fetchStatus,
  }
})
